import { useEffect, useState } from "react";
import { API_URL } from "../config";

export default function useGlobalTestimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/testimonios?global=true&limit=20`, {
          signal: controller.signal,
        });
        if (!res.ok) {
          return;
        }
        const data = await res.json();
        if (!controller.signal.aborted) {
          setTestimonials(Array.isArray(data?.items) ? data.items : []);
        }
      } catch (err) {
        if (err.name !== "AbortError") {
          setTestimonials([]);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    })();
    return () => controller.abort();
  }, []);

  return { testimonials, loading };
}
